<app-dynamic-image-widget [config]="config" [url]="url"></app-dynamic-image-widget>
